// extracted by mini-css-extract-plugin
export var errorIcon = "_jb-1";
export var nameLogo = "_jb-0";